import { getModule } from '@/store/store'
import PageState from './state'
import mutations from './mutations'

const APIS = {
  getSpeakerEmotionList: `get /apis/baohuo-yuanchuang/v1/speaker/getSpeakerEmotionList`, // 获取所有发音人风格
  getDefaultSpeaker:`get /apis/baohuo-yuanchuang/speaker/store/search`,//获取默认发音人
  queryMemberLeftRight:'get /apis/baohuo-account/v1/memberCenter/queryMemberLeftRight',
  draftWash: `post /apis/baohuo-yuanchuang/intelligent/edit/draft/wash`, // 洗稿(解析视频)
  
  extractShareLink: `post /apis/baohuo-yuanchuang/v1/video/extract/share_link`, // 解析短视频链接
  videoTutorial: `get /apis/baohuo-yuanchuang/v1/videoTutorial/queryByType?videoType=智能剪辑讲解`, // 新手教程

  translateTaskCreate: `post /apis/baohuo-yuanchuang/v2/video/translate/create`, // 创建视频翻译任务
  getTranslateTaskDetail: `get /apis/baohuo-yuanchuang/v2/video/translate/detail`, // 视频翻译任务详情查询
  updateTranslateTaskParam: `post /apis/baohuo-yuanchuang/v2/video/translate/update/param`, // 修改视频翻译任务参数

  rewriteTextAsync: `post /apis/baohuo-yuanchuang/v1/text/rewrite/async`, // 异步改写文案
  getRewriteResult: `get /apis/baohuo-yuanchuang/v1/text/rewrite/result`, // 轮询异步改写文案结果

  doSubmitArticle: `post /apis/baohuo-yuanchuang/oneClick/article/submit`, // 文章-提交
}

export default {
  ...getModule({
    name: 'SmartClip',
    state: new PageState(),
    mutations,
    APIS
  })
}
